/**
 * Shared React Query keys for company-scoped filter option lists.
 * Keep these in sync so observers (e.g. Property History filters + autocomplete)
 * hit the same cache entry.
 */

export function companyCityOptionsQueryKey(
  companyId: string | null,
): readonly [string] {
  return [`job/company/${companyId}/cities`];
}

export function companyRouteOptionsQueryKey(
  companyId: string | null,
): readonly [string] {
  return [`route/company/${companyId}?take=10000`];
}

export function companyPropertyOptionsQueryKey(
  companyId: string | null,
): readonly [string] {
  return [
    `job/company/${companyId}/?${new URLSearchParams({
      skip: "0",
      take: "3000",
    })}`,
  ];
}
